import { render, staticRenderFns } from "./MainContacts.vue?vue&type=template&id=2590831c&"
import script from "./MainContacts.vue?vue&type=script&lang=js&"
export * from "./MainContacts.vue?vue&type=script&lang=js&"
import style0 from "./MainContacts.vue?vue&type=style&index=0&id=2590831c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports